module.exports = __webpack_public_path__ + "static/media/circle-remove.3d0aa7f6.svg";